import { useMemo } from 'react';
import BasicsHero from '@/pages/forex-basics/components/BasicsHero';
import BasicsLearningPath from '@/pages/forex-basics/components/BasicsLearningPath';
import BasicsCategories from '@/pages/forex-basics/components/BasicsCategories';
import PriceExample from '@/pages/forex-basics/components/PriceExample';
import KnowledgeReview from '@/pages/forex-basics/components/KnowledgeReview';
import NextLearningStep from '@/pages/forex-basics/components/NextLearningStep';
import { siteOrigin, useSeo } from '@/hooks/useSeo';
import { forexBasicsCategories } from '@/mocks/forexBasics';

export default function ForexBasics() {
  const jsonLd = useMemo(() => {
    const origin = siteOrigin();
    const parts = forexBasicsCategories.flatMap((category) =>
      category.topics.map((topic) => ({
        '@type': 'Article',
        headline: topic.label,
        url: `${origin}${topic.to}`,
      })),
    );

    return [
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'หน้าแรก', item: `${origin}/` },
          { '@type': 'ListItem', position: 2, name: 'Forex พื้นฐาน', item: `${origin}/forex-basics` },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Forex พื้นฐาน',
        description:
          'รวมความรู้ Forex พื้นฐานสำหรับมือใหม่ แบ่งเป็น 6 หมวด ตั้งแต่ตลาด Forex คู่เงินและราคา คำศัพท์ Leverage Margin ต้นทุน ไปจนถึงความเสี่ยง',
        inLanguage: 'th-TH',
        url: `${origin}/forex-basics`,
        hasPart: parts,
      },
    ];
  }, []);

  useSeo({
    /* @replace:basics-title */
    title: 'Forex พื้นฐานสำหรับมือใหม่ | เรียน Forex 6 หมวด เริ่มจากศูนย์',
    description:
      /* @replace:basics-description */
      'รวม Forex พื้นฐานที่มือใหม่ต้องรู้ 6 หมวด ตั้งแต่ Forex คืออะไร คู่เงิน Bid/Ask Spread Pip Leverage Margin ไปจนถึงความเสี่ยง พร้อมตัวอย่างราคา EUR/USD อธิบายเข้าใจง่าย',
    /* @replace:basics-keywords */
    keywords: 'Forex พื้นฐาน, Forex คืออะไร, คู่เงิน, Pip, Spread, Leverage, Margin, Bid Ask, เรียน Forex มือใหม่',
    canonicalPath: '/forex-basics',
    jsonLd,
  });

  return (
    <>
      <BasicsHero />
      <BasicsLearningPath />
      <BasicsCategories />
      <PriceExample />
      <KnowledgeReview />
      <NextLearningStep />
    </>
  );
}